import {
  Breadcrumb,
  Button,
  Card,
  DatePicker,
  Divider,
  Empty,
  Form,
  Input,
  Modal,
  Radio,
  Select,
  Tabs,
  Tooltip,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import AccountService from "../../../../services/accounts.service";
import moment from "moment";
import { AiOutlineInfoCircle, AiOutlineLeft } from "react-icons/ai";
import { useSelector } from "react-redux";
import { ReactComponent as HomeIcon } from "../../../../assests/images/home-line.svg";
import {
  accountListSelector,
  profileDetailsSelector,
} from "../../../../store/selectors/app.selector";
import {
  amountFormat,
  maskAccountNumber,
} from "../../../../services/common.service";
import { MdOutlineEdit } from "react-icons/md";
import SetStatementRemarks from "../statement-remarks";
import { ReactComponent as TitleIcon } from "../../../../assests/images/accountBread.svg";
import { useTranslation } from "react-i18next";
import { ReactComponent as TickIcon } from "../../../../assests/images/tickIcon.svg";
import DetailedStatementGrid from "../../../../components/detailed-statement-grid";
import DetailedStatementList from "../../../../components/detailed-statement-list";

const remarksBill = require("../../../../assests/icons/d_bill.png");
const remarksBusiness = require("../../../../assests/icons/d_business.png");
const remarksEntertainment = require("../../../../assests/icons/d_entertainment.png");
const remarksfood = require("../../../../assests/icons/d_food.png");
const remarksHelth = require("../../../../assests/icons/d_health.png");
const remarksOthers = require("../../../../assests/icons/d_others.png");
const remarksShopping = require("../../../../assests/icons/d_shopping.png");
const remarksTravel = require("../../../../assests/icons/d_travel.png");
const remarksInvestment = require("../../../../assests/icons/d_investment.png");

const remarksIcons = {
  FOOD: remarksfood,
  ENTERTAINMENT: remarksEntertainment,
  BILLS: remarksBill,
  TRAVEL: remarksTravel,
  HEALTH: remarksHelth,
  INVESTMENT: remarksInvestment,
  SHOPPING: remarksShopping,
  BUSINESS: remarksBusiness,
  OTHERS: remarksOthers,
};

export default function DetailedStatement() {
  const navigate = useNavigate();
  const location = useLocation();
  const accList = useSelector(accountListSelector);
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [loader1, setLoader1] = useState(false);
  const [range, setRange] = useState("CURRENT");
  const [form] = Form.useForm();
  const [emailStatementform] = Form.useForm();
  const [stage, setStage] = useState(1);
  const [type, setType] = useState("PDF");
  const [fileName, setFileName] = useState("");
  const profileDetails = useSelector(profileDetailsSelector);
  const [remarkVisible, setRemarkVisible] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [accountDetails, setAccountDetails] = useState({});
  const [selectedDetails, setSelectedDetails] = useState({});
  const [accDetails, setAccDetails] = useState({});
  const { t } = useTranslation();
  const [reqValues, setReqValues] = useState({
    lastPstdDate: "",
    lastTxnDate: "",
    lastBalAmt: "",
    lastBalCcy: "",
    lastTxnId: "",
    lastTxnSrlNo: "",
    hasMoreData: "N",
  });
  const [activeKey, setActiveKey] = useState("ACCOUNT_DETAILS");
  const [showModal, setShowModal] = useState(false);
  const [order, setOrder] = useState("Ascending");
  const [maskAccount, setMaskAccount] = useState(true);
  const [emailPdf, setEmailPdf] = useState("sendEmail");
  const [message, setMessage] = useState("");
  const [successVisible, setSuccessVisible] = useState(false);
  const [pwdSuccessVisible, setPwdSuccessVisible] = useState(false);
  const [showGridAccount, setShowGridAccount] = useState("GRID");
  const [noRecords, setNoRecords] = useState(false);

  const sorting = [
    {
      label: t("pages.my_accounts.deposits.ascending", {
        defaultValue: "Ascending",
      }),
      value: "A",
    },
    {
      label: t("pages.my_accounts.deposits.descending", {
        defaultValue: "Descending",
      }),
      value: "D",
    },
  ];

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);

  useEffect(() => {
    if (location.pathname === "/accounts/statement/detailed") {
      setActiveKey("DETAILED_STATEMENT");
    } else {
      setActiveKey("ACCOUNT_DETAILS");
    }
    if (location.state) {
      setAccountDetails(location.state);
      form.setFieldsValue({
        accountNo: location.state?.accountNo,
        sortIn: "A",
        rangeType: "CURRENT",
      });
    }
  }, []);

  // const handleTabClick = (key) => {
  //   setActiveKey(key);
  //   if (key === "ACCOUNT_DETAILS") {
  //     navigate("/accounts/summary", { state: accountDetails });
  //   }
  //   if (key === "MINI_STATEMENT") {
  //     navigate("/accounts/statement", { state: accountDetails });
  //   }
  //   if (key === "E_STATEMENT") {
  //     navigate("/accounts/statement/eStatement", {
  //       state: accountDetails,
  //     });
  //   }
  //   if (key === "VIEW_BALANCES") {
  //     navigate("/accounts/summary/balances", {
  //       state: accountDetails,
  //     });
  //   }
  // };

  const onVerify = useCallback(
    async (values) => {
      try {
        let fromDate = "";
        let toDate = "";
        const accDetails = accList.find(
          (ele) => ele.accountNo === values.accountNo
        );
        if (range === "CURRENT") {
          fromDate = moment().startOf("month").format("YYYY-MM-DD");
          toDate = moment().format("YYYY-MM-DD");
        }
        if (range === "3_MONTHS") {
          fromDate = moment().subtract(3, "month").format("YYYY-MM-DD");
          toDate = moment().format("YYYY-MM-DD");
        }
        if (range === "6_MONTHS") {
          fromDate = moment().subtract(6, "month").format("YYYY-MM-DD");
          toDate = moment().format("YYYY-MM-DD");
        }

        if (range === "CUSTOM") {
          if (values.dateRange !== undefined) {
            fromDate = values.dateRange[0].format("YYYY-MM-DD");
            toDate = values.dateRange[1].format("YYYY-MM-DD");
          }
        }

        setAccDetails(accDetails);

        const reqParams = {
          accountNo: values.accountNo,
          branchId: accDetails.branchId,
          fromDate: fromDate,
          toDate: toDate,
          transactionType: "",
          sortIn: values.sortIn,
          lastPstdDate: "",
          lastTxnDate: "",
          lastBalAmt: "",
          lastBalCcy: "",
          lastTxnId: "",
          lastTxnSrlNo: "",
          hasMoreData: "N",
        };
        setFormValues({ ...reqParams, ...values, fromDate, toDate });
        setLoader(true);
        const response = await AccountService.getfullacctstmtwithpagination(
          reqParams
        );
        if (response.status === 200) {
          setLoader(false);
          setDataSource(response.data["statement"]);
          setNoRecords(response.data["statement"].length > 0 ? false : true);
          setStage(2);
          setReqValues({
            lastPstdDate: response.data["lastPstdDate"],
            lastTxnDate: response.data["lastTxnDate"],
            lastBalAmt: response.data["lastBalAmt"],
            lastBalCcy: response.data["lastBalCcy"],
            lastTxnId: response.data["lastTxnId"],
            lastTxnSrlNo: response.data["lastTxnSrlNo"],
            hasMoreData: response.data["hasMoreData"],
          });
        }
      } catch (error) {
        setLoader(false);
        setNoRecords(true);
      }
    },
    [reqValues, range]
  );

  const fetchMoreStatements = useCallback(async () => {
    try {
      const reqParams = {
        ...formValues,
        ...reqValues,
      };

      setLoader(true);
      const response = await AccountService.getfullacctstmtwithpagination(
        reqParams
      );
      if (response.status === 200) {
        setLoader(false);
        setDataSource([
          ...dataSource,
          ...response.data["fullStmtPaginationrRecords"],
        ]);
        setReqValues({
          lastPstdDate: response.data["lastPstdDate"],
          lastTxnDate: response.data["lastTxnDate"],
          lastBalAmt: response.data["lastBalAmt"],
          lastBalCcy: response.data["lastBalCcy"],
          lastTxnId: response.data["lastTxnId"],
          lastTxnSrlNo: response.data["lastTxnSrlNo"],
          hasMoreData: response.data["hasMoreData"],
        });
      }
    } catch (error) {}
  }, [reqValues, formValues, dataSource]);

  const statementDownload = useCallback(
    async (format) => {
      try {
        let fromDate = "";
        let toDate = "";

        console.log(formValues);
        if (range === "CURRENT") {
          fromDate = moment().startOf("month").format("YYYY-MM-DD");
          toDate = moment();
        }

        if (range === "3_MONTHS") {
          fromDate = moment().subtract(3, "month");
          toDate = moment();
        }
        if (range === "6_MONTHS") {
          fromDate = moment().subtract(6, "month");
          toDate = moment();
        }

        if (range === "CUSTOM") {
          if (formValues.dateRange !== undefined) {
            fromDate = formValues.dateRange[0]?.format("YYYY-MM-DD");
            toDate = formValues.dateRange[1]?.format("YYYY-MM-DD");
          }
        }
        setType(format);
        setLoader1(true);
        const response = await AccountService.statementDownload({
          fromDate: fromDate,
          toDate: toDate,
          accountNo: formValues?.accountNo,
          branchCode: formValues?.branchId,
          transactionType: "All",
          format: format,
          sortIn: formValues.sortIn,
          accountMask: maskAccount,
        });
        if (response.status === 200) {
          setLoader1(false);
          // if (format === "PDF") {
          //   setFileName(response.data["fileName"]);
          //   setVisible(true);
          // }
          setFileName(response.data["fileName"]);
          setPwdSuccessVisible(true);
        }
      } catch (error) {
        setLoader1(false);
      }
    },
    [formValues, range, maskAccount]
  );

  const emailStatement = useCallback(async () => {
    try {
      let fromDate = "";
      let toDate = "";
      if (range === "CURRENT") {
        fromDate = moment().startOf("month").format("YYYY-MM-DD");
        toDate = moment();
      }

      if (range === "3_MONTHS") {
        fromDate = moment().subtract(3, "month");
        toDate = moment();
      }
      if (range === "6_MONTHS") {
        fromDate = moment().subtract(6, "month");
        toDate = moment();
      }

      if (range === "CUSTOM") {
        if (formValues.dateRange !== undefined) {
          fromDate = formValues.dateRange[0]?.format("YYYY-MM-DD");
          toDate = formValues.dateRange[1]?.format("YYYY-MM-DD");
        }
      }
      setLoader1(true);
      const response = await AccountService.emailStatement({
        fromDate: fromDate,
        toDate: toDate,
        accountNo: formValues?.accountNo,
        branchCode: formValues?.branchId,
        transactionType: "All",
        emailId: emailStatementform?.getFieldValue("emailId"),
        maskAccount: maskAccount,
        sortIn: formValues.sortIn,
      });
      if (response.status === 200) {
        setLoader1(false);
        // if (format === "PDF") {
        //   setFileName(response.data["fileName"]);
        //   setVisible(true);
        // }
        setMessage(response.data["message"]);
        emailStatementform?.resetFields();
        setSuccessVisible(true);
      }
    } catch (error) {
      setLoader1(false);
    }
  }, [formValues, range, maskAccount, order]);

  const statementExcelDownload = useCallback(async () => {
    try {
      let fromDate = "";
      let toDate = "";

      console.log(formValues);
      if (range === "CURRENT") {
        fromDate = moment().startOf("month").format("YYYY-MM-DD");
        toDate = moment();
      }

      if (range === "3_MONTHS") {
        fromDate = moment().subtract(3, "month");
        toDate = moment();
      }
      if (range === "6_MONTHS") {
        fromDate = moment().subtract(6, "month");
        toDate = moment();
      }

      if (range === "CUSTOM") {
        if (formValues.dateRange !== undefined) {
          fromDate = formValues.dateRange[0]?.format("YYYY-MM-DD");
          toDate = formValues.dateRange[1]?.format("YYYY-MM-DD");
        }
      }
      // setType(format);
      setLoader1(true);
      const response = await AccountService.statementExcelDownload({
        fromDate: fromDate,
        toDate: toDate,
        accountNo: formValues?.accountNo,
        branchCode: formValues?.branchId,
        transactionType: "All",
        format: "",
        sortIn: formValues.sortIn,
      });
      if (response.status === 200) {
        setLoader1(false);
        // if (format === "PDF") {
        //   setFileName(response.data["fileName"]);
        //   setVisible(true);
        // }
        setFileName(response.data["fileName"]);
      }
    } catch (error) {
      setLoader1(false);
    }
  }, [formValues, range]);

  const analyzeTransactions = useCallback(async () => {
    const transactionsList = [];
    dataSource?.forEach((ele) => {
      transactionsList.push({
        transactionDate: ele.txnValuedDate,
        description: ele.txnTypeDesc,
        debit: ele.debitOrCredit === "Debit" ? ele.amount : 0,
        credit: ele.debitOrCredit === "Credit" ? ele.amount : 0,
        balance: ele.balance,
      });
    });
    const reqParams = {
      transactions: [...transactionsList],
    };
    try {
      const response = await fetch(
        "https://tigios.techurate.com/tdocs/analyzeTransactions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(reqParams),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error(errorData.error || "Something went wrong");
        setLoader(false);
      } else {
        const respData = await response.json();
        navigate("/statement-analyzer", {
          state: { ...respData },
        });
        setLoader(false);
      }
    } catch (err) {
      console.error("Network or server error:", err);
    }
  }, [dataSource]);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <Card className="application-card statement-card">
            <Form
              layout="vertical"
              form={form}
              initialValues={formValues}
              onFinish={onVerify}
            >
              <div className="row">
                <div className="col-12">
                  <Form.Item
                    label={t("common.selectAccount", {
                      defaultValue: "Select Account",
                    })}
                    name="accountNo"
                    rules={[
                      {
                        required: true,
                        message: t("errorMesssages.account_no_requir", {
                          defaultValue: "Account Number is required",
                        }),
                      },
                    ]}
                  >
                    <Select
                      placeholder={t("common.account_no_lbl", {
                        defaultValue: "Account Number",
                      })}
                      optionLabelProp={"value"}
                      size="large"
                    >
                      {accList.map((option, idx) => (
                        <Select.Option key={idx} value={option.accountNo}>
                          <span className="acc-short-name">
                            {option?.acctShortName}
                          </span>
                          <br />
                          <span style={{ fontSize: "12px" }}>
                            {option?.accountNo}
                          </span>
                          <br />
                          <span style={{ fontSize: "12px" }}>
                            {option?.branchName}
                          </span>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                {/* <div className="col-12">
                <Form.Item
                  label="Type of Transaction"
                  name="type"
                  rules={[
                    {
                      required: true,
                      message: "Type of Transaction is required",
                    },
                  ]}
                >
                  <Select placeholder="Type of Transaction" size="large">
                    <Select.Option value="A">All</Select.Option>
                    <Select.Option value="D">Debit</Select.Option>
                    <Select.Option value="C">Credit</Select.Option>
                  </Select>
                </Form.Item>
              </div> */}

<div className="col-12">
                <Form.Item label="" name="rangeType">
        <Radio.Group
          onChange={(e) => setRange(e.target.value)}
          className="row g-2"
        >
          <div className="col-6 col-md-3">
            <Radio value="CURRENT">
              {t("pages.my_accounts.casa.current_month", { defaultValue: "Current Month" })}
            </Radio>
          </div>

          <div className="col-6 col-md-3">
            <Radio value="3_MONTHS">
              {t("pages.my_accounts.casa.three_months", { defaultValue: "3 Months" })}
            </Radio>
          </div>

          <div className="col-6 col-md-3">
            <Radio value="6_MONTHS">
              {t("pages.my_accounts.casa.six_months", { defaultValue: "6 Months" })}
            </Radio>
          </div>

          <div className="col-6 col-md-3">
            <Radio value="CUSTOM">
              {t("pages.my_accounts.common_my_accounts.date_range", { defaultValue: "Date Range" })}
            </Radio>
          </div>
        </Radio.Group>
      </Form.Item>
                </div>

                {range === "CUSTOM" && (
                  <div className="col-12">
                    <Form.Item label="" name="dateRange">
                      <DatePicker.RangePicker
                        // disabledDate={(current) => {
                        //   return (
                        //     current &&
                        //     (current.isAfter(moment().endOf("day")) ||
                        //       current.isBefore(
                        //         moment().subtract(6, "months").startOf("day")
                        //       ))
                        //   );
                        // }}
                        disabledDate={(current) => {
                          return (
                            current && current.isAfter(moment().endOf("day"))
                          );
                        }}
                        format={"DD-MM-YYYY"}
                        style={{ width: "100%" }}
                        size="large"
                      />
                    </Form.Item>
                  </div>
                )}
                <div className="col-12">
                  <Form.Item name="sortIn" label="Order By">
                    <Select bordered={true} size="large">
                      {sorting.map((option, idx) => (
                        <Select.Option key={idx} value={option.value}>
                          {option.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>
              <div className="d-flex justify-content-end  mt-3">
                <Button
                  className="btn-primary"
                  size="large"
                  type="default"
                  htmlType="submit"
                >
                  {t("buttons.view_btn", {
                    defaultValue: "View",
                  })}
                </Button>
              </div>
            </Form>
          </Card>
        </div>
      </div>
    );
  }

  function renderConfirm() {
    return (
      <>
        <div className="dashboard-accounts-wrapper">
          <div className="hide-xs">
            {" "}
            <div className="row">
              <div className="col-10">
                <Form layout="inline">
                  <Form.Item
                    label={t("pages.my_accounts.casa.range", {
                      defaultValue: "Range",
                    })}
                    name="rangeType"
                  >
                    <span>
                      {range === "CURRENT" &&
                        t("pages.my_accounts.casa.current_month", {
                          defaultValue: "Current Month",
                        })}
                    </span>
                    <span>
                      {range === "3_MONTHS" &&
                        t("pages.my_accounts.casa.last_three_months", {
                          defaultValue: " Last 3 Months",
                        })}
                    </span>
                    <span>
                      {range === "6_MONTHS" &&
                        t("pages.my_accounts.casa.last_six_months", {
                          defaultValue: " Last 6 Months",
                        })}
                    </span>
                    <span>
                      {range === "CUSTOM" && (
                        <>
                          {t("common.from_date", {
                            defaultValue: "From Date",
                          })}{" "}
                          : {moment(formValues?.fromDate).format("DD-MM-YYYY")}{" "}
                          {t("common.to_date", {
                            defaultValue: "To Date",
                          })}{" "}
                          : {moment(formValues?.toDate).format("DD-MM-YYYY")}
                        </>
                      )}
                    </span>
                  </Form.Item>
                  <Button
                    type="link"
                    onClick={() => setStage(1)}
                    className="mx-2"
                  >
                    {t("buttons.back_to_search_btn", {
                      defaultValue: "Back to Search",
                    })}
                  </Button>
                </Form>
              </div>
              <div className="d-flex justify-content-end statement-footer col-2">
                {dataSource.length > 0 && (
                  <>
                    {/* <Tooltip
                        placement="top"
                        title={""}
                        overlayInnerStyle={{ textAlign: "center" }}
                      >
                        <Button
                          size="small"
                          type="link"
                          onClick={() => analyzeTransactions()}
                        >
                          Statement analyzer
                        </Button>
                      </Tooltip> */}

                    <Divider type="vertical" className="mt-2" />
                    <Tooltip
                      placement="top"
                      title={""}
                      overlayInnerStyle={{ textAlign: "center" }}
                    >
                      <Button
                        size="small"
                        type="link"
                        onClick={() => {
                          setShowModal(true);
                          emailStatementform.setFieldsValue({
                            maskAccountNo: true,
                            allemailpdf: "sendEmail",
                          });
                        }}
                      >
                        {t("buttons.download_pdf_btn", {
                          defaultValue: "Download As PDF",
                        })}
                      </Button>
                    </Tooltip>

                    <Divider type="vertical" className="mt-2" />
                    <Tooltip
                      placement="top"
                      title={""}
                      overlayInnerStyle={{ textAlign: "center" }}
                    >
                      <Button
                        size="small"
                        type="link"
                        onClick={() => statementExcelDownload()}
                      >
                        {t("buttons.download_excel_btn", {
                          defaultValue: "Download As Excel",
                        })}
                      </Button>
                    </Tooltip>
                  </>
                )}

                {/* <Divider type="vertical" />
                <Tooltip
                  placement="top"
                  title={""}
                  overlayInnerStyle={{ textAlign: "center" }}
                >
                  <Button
                    size="small"
                    type="link"
                    loading={type === "CSV" && loader1}
                    onClick={() => statementDownload("CSV")}
                  >
                    Download As CSV
                  </Button>
                </Tooltip> */}
              </div>
            </div>
          </div>

          {showGridAccount === "GRID" && (
            <DetailedStatementGrid
              dataSource={dataSource}
              fetchMoreStatements={fetchMoreStatements}
              accDetails={accDetails}
              reqValues={reqValues}
              setRemarkVisible={setRemarkVisible}
              setSelectedDetails={setSelectedDetails}
              remarksIcons={remarksIcons}
              noRecords={noRecords}
            />
          )}
          {showGridAccount === "LIST" && (
            <DetailedStatementList
              dataSource={dataSource}
              fetchMoreStatements={fetchMoreStatements}
              reqValues={reqValues}
              setShowModal={setShowModal}
              statementExcelDownload={statementExcelDownload}
              emailStatementform={emailStatementform}
              noRecords={noRecords}
            />
          )}
        </div>

        {/* // )} */}
      </>
    );
  }

  return (
    <>
      {/* 
      
        <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span onClick={() => navigate("/accounts")}>
              {t("navigation.account", {
                defaultValue: "Accounts",
              })}
            </span>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span>
              {t("buttons.detailed_stmt_btn", {
                defaultValue: "Detailed Statement",
              })}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> }
            <h3 className="title mb-0">
              {t("buttons.detailed_stmt_btn", {
                defaultValue: "Detailed Statement",
              })}
            </h3>
          </div>
        </div>
      </Card>

      <Card className="account-tab-card mb-1">
        <Tabs
          defaultActiveKey="1"
          type="line"
          onChange={setActiveKey}
          activeKey={activeKey}
          onTabClick={handleTabClick}
        >
          <Tabs.TabPane
            tab={t("pages.gepeg.account_details", {
              defaultValue: "Account Details",
            })}
            key="ACCOUNT_DETAILS"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.gepeg.view_balances", {
              defaultValue: "View Balances",
            })}
            key="VIEW_BALANCES"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("navigation.statement", {
              defaultValue: "Statement",
            })}
            key="MINI_STATEMENT"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("buttons.detailed_stmt_btn", {
              defaultValue: "Detailed Statement",
            })}
            key="DETAILED_STATEMENT"
          ></Tabs.TabPane>
          <Tabs.TabPane
            tab={t("pages.my_accounts.casa.eStatement_Request", {
                      defaultValue: "eStatement Request",
                    })}
            key="E_STATEMENT"
          ></Tabs.TabPane>
        </Tabs>
      </Card> */}

      {renderSwitch()}

      <Modal
        title={t("pages.my_accounts.casa.full_statement", {
          defaultValue: "Full Statement",
        })}
        closable={false}
        maskClosable={false}
        open={showModal}
        footer={null}
        width={600}
        mask={true}
      >
        <Form
          layout="vertical"
          form={emailStatementform}
          onFinish={() => {
            setShowModal(false);
            emailPdf === "downloadPdf"
              ? statementDownload("PDF")
              : emailStatement();
            setEmailPdf("sendEmail");
            setMaskAccount(true);
          }}
        >
          <div className="row">
            {/* <div className="col-12">
              <Form.Item label="Order By" name="orderBy" className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
                <Radio.Group
                  onChange={(e) => setOrder(e.target.value)}
                  className=" d-flex justify-content-between"
                >
                  <Radio value={"Ascending"}>Ascending</Radio>
                  <Radio value={"Descending"}>Descending</Radio>
                </Radio.Group>
              </Form.Item>
            </div> */}
            <div className="col-12">
              <Form.Item
                label={t("pages.my_accounts.casa.mask_account_number", {
                  defaultValue: "Mask Account Number",
                })}
                name="maskAccountNo"
                className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4"
              >
                <Radio.Group
                  onChange={(e) => setMaskAccount(e.target.value)}
                  className=" d-flex justify-content-between"
                >
                  <Radio value={true}>
                    {" "}
                    {t("buttons.yes_btn", {
                      defaultValue: "Yes",
                    })}
                  </Radio>
                  <Radio value={false}>
                    {" "}
                    {t("buttons.no_btn", {
                      defaultValue: "No",
                    })}
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </div>
            <div className="col-12">
              <Form.Item
                label=""
                name="allemailpdf"
                className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
              >
                <Radio.Group
                  onChange={(e) => setEmailPdf(e.target.value)}
                  className=" d-flex justify-content-between"
                >
                  <Radio value={"sendEmail"}>
                    {t("pages.my_accounts.casa.send_to_email", {
                      defaultValue: "Send To Email",
                    })}
                  </Radio>
                  <Radio value={"downloadPdf"}>
                    {t("pages.my_accounts.casa.download_pdf", {
                      defaultValue: "Download PDF",
                    })}
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </div>

            {emailPdf === "sendEmail" ? (
              <div className="col-12">
                <Form.Item
                  label={t("common.email_id", {
                    defaultValue: "Email Id",
                  })}
                  name="emailId"
                  rules={[
                    {
                      required: true,
                      message: t("pages.profile.email_req_txt", {
                        defaultValue: "Email Id is required",
                      }),
                    },
                    {
                      type: "email",
                      message: t("pages.profile.invalid_email_txt", {
                        defaultValue: "Invalid Email Id",
                      }),
                    },
                  ]}
                >
                  <Input
                    maxLength={35}
                    placeholder={t("pages.my_accounts.casa.enter_emailId", {
                      defaultValue: "Enter Email Address",
                    })}
                    size="large"
                  />
                </Form.Item>
              </div>
            ) : null}
          </div>
          <div className="mt-3" align="right">
            <Button
              type="default"
              onClick={() => {
                setShowModal(false);
              }}
            >
              {t("buttons.close_btn", { defaultValue: "Close" })}
            </Button>

            <Button type="primary" style={{ marginLeft: 20 }} htmlType="submit">
              {t("buttons.submit_btn", {
                defaultValue: "Submit",
              })}
            </Button>
          </div>
        </Form>
      </Modal>

      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        // className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        title={""}
        open={pwdSuccessVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
      >
        <div
          style={{ width: 330, margin: "0 auto" }}
          align="center"
          className="mt-2"
        >
          <AiOutlineInfoCircle size={55} className="primary-color" />
          <h6
            className="auth-header-label"
            style={{ textTransform: "initial" }}
          >
            {t("pages.my_accounts.casa.pdf_pwd_txt", {
              defaultValue:
                "The PDF is secured with a password, which is a combination of the initial eight digits of your account number.",
            })}
          </h6>
          <div className="mt-4 mb-3" align="center">
            <Button
              type="primary"
              className="btn-primary"
              style={{ width: 120 }}
              size="large"
              onClick={() => {
                setPwdSuccessVisible(false);
              }}
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title={
          selectedDetails?.remarks !== null &&
          selectedDetails?.remarks?.length > 0
            ? t("pages.my_accounts.casa.edit_remarks", {
                defaultValue: "Edit Remarks",
              })
            : t("pages.my_accounts.casa.add_remarks", {
                defaultValue: "Add Remarks",
              })
        }
        closable={false}
        maskClosable={false}
        open={remarkVisible}
        footer={null}
        width={420}
        mask={true}
      >
        <SetStatementRemarks
          key={new Date().getTime()}
          setVisible={setRemarkVisible}
          selectedDetails={{
            ...selectedDetails,
            debitOrCredit: selectedDetails?.debitOrCredit,
            referenceNumber: selectedDetails?.refNo,
          }}
          accountDetails={{ accountNo: formValues?.accountNo }}
          setRefresh={() => {
            setRemarkVisible(false);
            onVerify(formValues);
          }}
        />
      </Modal>
    </>
  );
}
